/* unplugin-vue-components disabled */import { render } from "./Image.vue?vue&type=template&id=725a0e08&scoped=true"
import script from "./Image.vue?vue&type=script&lang=js"
export * from "./Image.vue?vue&type=script&lang=js"

import "./Image.vue?vue&type=style&index=0&id=725a0e08&lang=scss&scoped=true"

import exportComponent from "/data/repos/231_20260324095708/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-725a0e08"]])

export default __exports__